module.exports = __webpack_public_path__ + "static/media/voltmill-5.5edc4fcd.jpg";